import Vue from "../commonapp";
import App from "./app.vue";


new Vue({
    el: "#app",
    render: (h) => h(App),
});